// extracted by mini-css-extract-plugin
export var boxItems = "_a5-1";
export var boxItemsLg = "_a5-2";
export var button = "_a5-7";
export var buttonHoverless = "_a5-9";
export var buttonLg = "_a5-8";
export var filterGroupBox = "_a5-0";
export var icon = "_a5-3";
export var iconSecondary = "_a5-6";
export var iconWrapper = "_a5-4";
export var iconWrapperLg = "_a5-5";
export var truncatedLabel = "_a5-a";